import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { bankDetailsQueryKeys } from "../query-keys";
import { ApiBankDetails } from "@ac-expo/api-types";

const getBankDetails = async (id: string | undefined, isStructure: boolean) => {
  const { data } = await privateAxios.get<ApiBankDetails[]>(`/bank-details`, {
    params: {
      structureId: isStructure ? id : undefined,
      organiserId: isStructure ? undefined : id,
    },
  });
  return data;
};

export const useGetBankDetailsQuery = (
  id: string | undefined,
  isStructure: boolean
) => {
  return useQuery({
    queryKey: [bankDetailsQueryKeys.all, id, isStructure],
    queryFn: () => getBankDetails(id, isStructure),
  });
};

const getBankDetailsById = async (id: string) => {
  const { data } = await privateAxios.get(`/bank-details/${id}`);
  return data;
};

export const useGetBankDetailsByIdQuery = (id: string | null) => {
  return useQuery({
    queryKey: [bankDetailsQueryKeys.all, "byId", id],
    queryFn: () => getBankDetailsById(id!),
    enabled: !!id,
  });
};
